module.exports = __webpack_public_path__ + "static/scale-model-of-denver-art-museum-in-denver-colorado-689e7ee54956af9788ed1ae9f62563c4.png";